import { createOnAndOffNamespaceListeners, } from "./utils.js";
import { invoke } from "./invoke.js";
import { checkIfCompatibleWithBackend } from "@todesktop/client-util";
export async function getDefaultSession() {
    if (checkIfCompatibleWithBackend("session:getDefaultSession", "4.17.0")) {
        return invoke({
            namespace: "session",
            property: "defaultSession",
        });
    }
}
export async function fromPartition(partition, options) {
    if (checkIfCompatibleWithBackend("session:fromPartition", "4.17.0")) {
        return invoke({
            namespace: "session",
            method: "fromPartition",
            args: [partition, options],
        });
    }
}
const listeners = createOnAndOffNamespaceListeners("session", "4.17.0");
export const on = listeners.on;
export const removeAllListeners = listeners.removeAllListeners;
